// extracted by mini-css-extract-plugin
export default {"opportunities":"Opportunities_opportunities__05HJ9","opportunity":"Opportunities_opportunity__BBqfB","header":"Opportunities_header__qSmLD","card":"Opportunities_card__Z2rVm"};